import { deleteModelo } from "@spark/services/frotas";
import React, { useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Card, CardBody, CardTitle } from "@spark/ui-components/components/Card";
import { H3 } from "@spark/ui-components/components/Typography";
import PageHeader from "@spark/ui-components/components/BreadCrumb";
import { useHistory, useParams } from "react-router-dom";
import { ButtonWithLoading } from "@spark/ui-components/components/Button";
import styled from "styled-components";
import CadastrosModelosMain from "../Cadastro/index";
import { notification } from "@spark/ui-components/utils/notification";

const ModeloDetalhes = () => {
  const history = useHistory();
  const { id } = useParams();

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/modelo/editar/${id}`);
  }, [history, id]);

  const handleExcluir = useCallback(async () => {
    if (!window.confirm("Tem certeza que deseja excluir este modelo?")) {
      return;
    }

    try {
      await deleteModelo(id);
      notification.success("Modelo excluido com sucesso!");
      history.goBack();
    } catch (error) {
      console.error("Erro ao excluir modelo:", error);
    }
  }, [history, id]);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: "Inicio" },
              { name: "Modelos", route: "/pages/veiculos" },
              { name: "Detalhes" },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <CardTitle>
                  <H3>Detalhes do Modelo Veicular</H3>
                </CardTitle>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="outline-danger" onClick={handleExcluir}>
                    Excluir
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>
              <CadastrosModelosMain isReadOnly={true} id={id} hideHeader={true} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ModeloDetalhes;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
